"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");
/*
    Scoped Treble Hook
    Gives scoped treble components access to store.
*/


var useScopedTreble = function useScopedTreble() {
  return (0, _react.createContext)([]);
};

var _default = useScopedTreble;
exports["default"] = _default;
module.exports = exports["default"];